const styles = theme => ({
  grid: {
    alignContent: 'center',
    paddingLeft: '32px',
    paddingRight: '32px',
  },
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: 'auto auto auto',
    gridRowGap: 24,
  },
  headerLeft: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    maxWidth: 570,
    gridColumnStart: 1,
    gridColumnEnd: 3,
  },
  headerRight: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  main: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    gridColumnStart: 1,
    gridColumnEnd: 4,
  },
  footer: {
    gridColumnStart: 1,
    gridColumnEnd: 4,
  },
  wrapCalculator: {
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    padding: 24,
    background: theme.palette.background.paper,
  },
  label: {
    fontWeight: 600,
    alignItems: 'center',
    display: 'grid',
    paddingRight: 24,
  },
  label2: {
    fontWeight: 600,
    alignItems: 'center',
    display: 'grid',
    paddingRight: 24,
    minWidth: 96,
  },
  select: {
    width: 188,
    display: 'inline-block',
  },
  deleteIcon: {
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    '&:hover': {
      color: theme.palette.info.main,
    },
  },
  wrapFlexCenter: {
    display: 'flex',
    justifyContent: 'center',
    margin: '32px 0',
  },
  textContentCenter: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    '&:hover': {
      color: theme.palette.info.main,
    },
  },
  textContentHover: {
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.info.main,
    },
  },
  standardSelect: {
    width: '100%',
    backgroundColor: theme.palette.background.subtle,
    borderRadius: '4px',
    height: '36px',
    color: theme.palette.text.secondary,
  },
  round: {
    width: 70,
    display: 'inline-block',
  },
});
export default styles;
